import { FeatureInfo } from './../../components/draw-pane/draw-pane.component';
import { FeatureData } from 'app/model/project';
import { IDRegistry } from './../id-registry';
import { AttributeOption, AttributeId, AttributeOptionId, ConfigAttributeDefault, CalcInfo, AttributeConfigId, AttributeStyle, ConfigAttribute, AttributeFeatureType, CalcUtil } from './../../types/project-config';
import { ObjID } from 'app/model/id-manager';
import { RouteFeature, RoutePart, AttributeTally } from './../mapping/drawing/RouteFeature';
import { Route, Costs } from './../../types/route-data';
import { Criterion } from './../comparisons';
import { Comparisons } from 'app/model/comparisons';
import { IDKeyTypes } from 'app/model/id-manager';
import { DrawingFeatureType } from './../mapping/drawing/Feature';
import { Feature, IFeature } from 'app/model/mapping/drawing/Feature';

import { AnyHandler, SimpleHandler, TypedHandler } from './../../types/handlers';

import { Injectable, ErrorHandler, EventEmitter } from '@angular/core';
import { Project } from '../project';
import { Utils } from '../utils';
import { evaluate, identity } from 'mathjs';
import { RouteInfo } from './route.service';


export type RouteTally = { [key in ObjID]?: AttributeTally }

export type FeatureSelection = {
  route: RouteFeature;
  routePart: RoutePart;
  feature: ObjID;
  changedFields?: {
    [key in ObjID]: boolean;
  }
  dataOld?: FeatureData;
}
export type FeatureChange = {
  changer?: string,
  route: RouteFeature,
  routePart: RoutePart,
  dataOld: FeatureData | undefined
}
@Injectable({
  providedIn: 'root',
})
export class DataManagerService {
  static instance?: DataManagerService;
  private project?: Project;
  private selected?: FeatureSelection;
  public onSelect = new EventEmitter<FeatureSelection>();
  public onFeatureUpdate = new EventEmitter<FeatureChange>();
  private value: number = 0;
  private tally: any = {};
  constructor() {
    DataManagerService.instance = this;
    this.SetupFeatureFactory();
  }

  HasChanges() {

    if (this.selected?.changedFields === undefined) return false;
    for (const change in this.selected?.changedFields) {
      if (this.selected.changedFields[change] === true) return true;
    }
    return false;
  }
  FeatureUpdated(updater?: string) {
    if (!this.selected) return;
    const change: FeatureChange = {
      route: this.selected.route,
      routePart: this.selected.routePart,
      dataOld: this.selected.dataOld
    }
    console.log('before', this.selected.routePart.value);

    this.TallyRoutePart(this.selected.routePart);
    if (updater) {
      change.changer = updater;
    }
    this.RebuildStyle(this.selected.routePart);
    console.log('after', this.selected.routePart.value);
    this.onFeatureUpdate.emit(change);
  }
  RebuildStyle(routePart: RoutePart) {
    routePart.style = {};
    if (!routePart.data) return;
    for (const key of Object.keys(routePart.data)) {
      const attribute: ConfigAttribute = this.project?.GetAttributeById(key as ObjID) as ConfigAttribute;
      if (!attribute) continue;
      if (!attribute.options) continue;
      if (this.project?.idManager.IDType(routePart.data[key as any] as ObjID) !== IDKeyTypes.AttributeOption) {
        continue;
      }
      const option = this.project.idRegistry.Get(Number(routePart.data[key as any]) as ObjID) as AttributeOption;
      if (!option?.style) continue;
      this.MergeStyle(routePart.style, option.style);
    }
  }
  SelectFeature(featureId: ObjID, route: RouteFeature) {
    this.DeSelect();
    const feature: any = this.project?.idRegistry.Get(featureId);
    if (!feature) return;
    if (!feature.partId) return;
    const routePart: RoutePart = this.project?.idRegistry.GetByType(IDKeyTypes.RoutePart, feature.partId);
    /*if (!!this.selected) {
      if (this.selected.routePart) {
        const oldFeature = this.project!.idRegistry.Get(this.selected!.routePart.id!);
        if (oldFeature) {
          oldFeature.DeselectFeature();
        }
      }
    }*/
    // feature.SelectFeature();
    this.selected = {
      route: route,
      feature: featureId,
      routePart: (routePart),
      changedFields: undefined
    };
    this.onSelect.emit(this.selected);
  }
  GetSelected(): FeatureSelection | undefined {
    return this.selected;
  }
  DeSelect() {
    if (!this.selected) return;
    const feature = this.project?.idRegistry.Get(this.selected.feature);
    for (const routeId of feature?.routes) {
      const route = this.project?.idRegistry.Get(routeId);
      route.feature?.DeselectFeature(feature.id)
    }
    // this.selected.route.DeselectFeature(this.selected.feature);
    this.selected = undefined;
    this.onSelect.emit();
  }
  FeatureRemoved(feature: any) {
    // ToDo:Handle Feature removal

  }
  SetupFeatureFactory() {
    Feature.SetIDFactory((type: DrawingFeatureType, feature: IFeature) => {
      switch (type) {
        case 'point':
          this.project?.idRegistry.RegisterObject(IDKeyTypes.PointFeature, feature);
          break;
        case 'line':
          this.project?.idRegistry.RegisterObject(IDKeyTypes.LineFeature, feature);
          break;
        case 'segment':
          this.project?.idRegistry.RegisterObject(IDKeyTypes.SegmentFeature, feature);
          break;
        case 'poly':
          this.project?.idRegistry.RegisterObject(IDKeyTypes.PolyFeature, feature);
          break;
      }
      (feature as any).data = this.GetDefaultData(feature as any);

    })

  }

  SetProject(project: Project) {
    this.project = project;
  }
  GetProject(): Project | undefined {
    return this.project;
  }
  MakeRoutePart(feature: RoutePart) {
    feature.id = this.project?.idManager.ID(IDKeyTypes.RoutePart) as ObjID;
    feature.data = this.GetDefaultData(feature);
    this.project?.idRegistry.RegisterObject(IDKeyTypes.RoutePart, feature);
    this.TallyRoutePart(feature);
  }
  UnTallyRoutePart(part: RoutePart) {
    if (!part.tally) return;
    for (const id in part.tally) {
      if (!part.tally.hasOwnProperty(id)) continue;
      part.tally[id]!.costs = { labor: 0, materials: 0 }
      part.tally[id]!.total = 0;
    }
    this.TallyRoutePart(part);
  }
  TallyRoutePart(part: RoutePart) {
    const includeLength = part.type === 'segment';
    if (!part.data) throw new Error('attempting to tally a route part before setting its data');
    const tallyData: any = {}
    const dataDelta: any = {}
    const tallyDelta: any = {};
    const valueOld = !!part.value ? part.value : 0;

    if (!part.tally) {
      part.tally = {}
    }
    part.value = 0;
    const oldTally = JSON.parse(JSON.stringify(part.tally));
    const costTally: any = {};
    for (const key in part.data) {
      const attribute = this.project?.idRegistry.Get(key as ObjID) as ConfigAttribute;
      const info = CalcUtil.GetCalcFromCalcName('attributes', attribute.calc);
      if (!info) continue;
      const combo = attribute.input + '-' + attribute.calc;
      if (!attribute.options?.length) continue;
      const attOption: AttributeOption = (attribute.input === 'selector') ?
        this.project?.idRegistry.Get(part.data[key] as AttributeOptionId) as AttributeOption
        : attribute.options[0] as AttributeOption;
      if (!attOption) continue;
      const costs = { ...attOption.cost as Costs };

      // Continue if given input requirements not met
      switch (attribute.input) {
        case 'checkbox':
          if (!part.data[key]) continue;
          break;
        case 'input':
          if (!part.data[key]) continue;
          if (part.data[key] === '') continue;
          break;
        case 'qty':
          if (!part.data[key]) continue;
          if (isNaN(Number(part.data[key]))) continue;
          if (Number(part.data[key]) < 0) continue;
          break;
        case 'selector':

          if (!attOption) continue;
          break;
      }

      const params: any = {};

      for (const costKey in costs) {
        if (!costs.hasOwnProperty(costKey)) continue;
        if (!costTally[costKey]) {
          costTally[costKey] = 0;
        }
        if (isNaN((costs as any)[costKey])) {
          (costs as any)[costKey] = 0;
        }
        costTally[costKey] += Number((costs as any)[costKey]);
        params[costKey] = Number((costs as any)[costKey]);
      }

      switch (attribute.calc) {
        case 'perft':
          if (!part.getLength) continue;
          params.length = part.getLength() as number;
          break;
        case 'qty':
          params.qty = Number(part.data[key]);
          break;
        case 'qtyperft':
          if (!part.getLength) continue;
          params.length = part.getLength() as number;
          params.qty = Number(part.data[key]);
          break;
      }
      let value = 0;
      try {
        value = evaluate(info.calc, params);
      } catch (e) {
        value = 0;
      }
      if (value) part.value = (part.value === undefined) ? value : part.value += value;
      let tallyKey = key;
      switch (attribute.input) {
        case 'selector':
          if (!!attOption) {
            tallyKey = '' + attOption.id;
          }
          break;
      }
      tallyData[tallyKey] = { costs: (costs), total: value };
    }
    part.tally = tallyData;
    part.costTally = costTally;
    part.valueOld = valueOld;
    part.tallyOld = oldTally;
    const route = this.project?.idRegistry.Get(part.routeId) as RouteInfo;
    route.feature?.UpdateValue(part);
  }
  GetDefaultData(feature: RoutePart) {
    const attributes = this.project?.GetConfigAttributes(feature.type as AttributeFeatureType);
    if (!attributes) {
      throw new Error('attempting to get default data when attributes are undefined');
    }
    feature.style = ({}) as AttributeStyle

    const data: any = {};
    // Loop through attributes and set default value or option id for each attribute id that is "available".
    for (const attribute of attributes) {
      if (attribute.displayAlways !== true) {
        if (!this.IsAvailable(feature, attribute, data)) {
          continue;
        }
      }
      let defaultVal: ConfigAttributeDefault | undefined = attribute.default;

      switch (attribute.input) {
        case 'selector':
          {
            const options = attribute.options;
            if (!options) continue;
            if (!defaultVal) {
              defaultVal = this.GetDefaultOption(feature, options);
            }
            if (defaultVal) {
              const option = this.project!.idRegistry.Get(defaultVal as ObjID) as AttributeOption;
              if (option.style) {
                this.MergeStyle(feature.style, option.style);
              }
            }
            /* if (feature.type !== 'point') {
               if (options[0].label.toLowerCase().trim().indexOf('select ') === 0) {
                 defaultVal = options[0].id;
                 break;
               } else {
                 continue;
               }
             } else {
               defaultVal = options[1].id;
             }*/
          }
          break;
        case 'input':
          defaultVal = '';
          break;
        case 'checkbox':
          defaultVal = false;
          break;
      }
      data[attribute.id] = defaultVal;
    }
    return data;
  }
  MergeStyle(style: AttributeStyle, mergeStyle: AttributeStyle) {
    const keys = Object.keys(mergeStyle);
    for (const key of keys) {
      (style as any)[key] = (mergeStyle as any)[key];
    }
  }
  GetDefaultOption(feature: RoutePart, options: Array<AttributeOption>): ObjID | undefined {
    switch (feature.type) {
      case 'point':
      case 'segment':
        if (options.length > 0) {
          if (feature.type === 'point') {

            if (options.length === 1) {
              return options[0].id;
            }
          }
        }
      default:
        if (options.length === 0) return undefined;
        return options[0].id;
    }

  }
  IsAvailable(feature: RoutePart, attribute: ConfigAttribute, data: any): boolean {
    if (attribute.displayAlways === true) return true;
    const availability = attribute.availability;
    if (!availability) return true;
    const atts = this.project?.GetConfigAttributes(feature.type as AttributeFeatureType);
    let hasMatch = false;
    for (const avail of availability) {
      switch (attribute.input) {
        case 'checkbox':
          hasMatch = hasMatch || (data[attribute.id] !== avail.value);
          if (hasMatch) return true;
          break;
        case 'selector':
          if (avail.option_id) {
            hasMatch = hasMatch || ('' + data[avail.attribute_id] === '' + avail.option_id);
            if (hasMatch) return true;
          }
          break;
        case 'input':
          const criteria: Criterion = {
            source: data[attribute.id] as string,
            comparison: avail.comparison,
            value: avail.value as string
          }
          const comparison = Comparisons[avail.comparison];
          const matched = comparison.Match(criteria);
          if (matched === true) {
            hasMatch = true;

          }
      }

    }
    return hasMatch;
  }

}
